import React, { useEffect, useState } from "react";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import "./PaymentFailure.css";
import {
  FaTimesCircle,
  FaCheckCircle,
  FaReceipt,
  FaExclamationTriangle,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchTransactionDetailsAPI } from "../../actioncreators/actioncreators";
const PaymentFailure = () => {
  const navigate = useNavigate();
  // Initialize with default values
  const [paymentData, setPaymentData] = useState({ });

  useEffect(() => {
    fetchTransactionDetail();
  }, []);

  const fetchTransactionDetail = async () => {
    try {
      const subscriptionId = localStorage.getItem("subscriptionId");

      const payload = {
        id: subscriptionId,
      };
      const response = await fetchTransactionDetailsAPI(payload); // Pass the payload to API
      setPaymentData(response.paymentDetails || {});
    } catch (err) {
      console.error("Error fetching transaction details:", err.message);
    }
  };

  return (
    <Container fluid className="payment-failure-container">
      <Row className="justify-content-center w-100">
        <Col md={11} lg={10} xl={8}>
          <Card className="payment-card border-0">
            <Card.Body className="p-3 p-md-4">
              <div className="text-center mb-4">
                {" "}
                <h2
                  className={
                    paymentData.status === "success"
                      ? "success-header mb-2"
                      : "failure-header mb-2"
                  }
                >
                  {paymentData.status === "success" ? (
                    <FaCheckCircle className="success-icon me-2" />
                  ) : (
                    <FaTimesCircle className="failure-icon me-2" />
                  )}
                  {paymentData.status === "success"
                    ? "Payment Successful"
                    : "Payment Failed"}
                </h2>
                <div className="amount-text mb-2">
                  ₹ {paymentData?.Amount ? Number(paymentData.Amount).toFixed(2) : '0.00'}
                </div>
                <p className="text-muted small mb-0">
                  Transaction ID:{" "}
                  <span className="fw-semibold" style={{ backgroundColor: '#f8f9fa', padding: '3px 8px', borderRadius: '4px' }}>
                    {paymentData.txnid || paymentData.Txnid || "N/A"}
                  </span>
                </p>
              </div>
              <Row className="details-row">
                <Col md={6} className="pe-md-2">
                  <div className="payment-details h-100" style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                    <h5 className="mb-3 d-flex align-items-center">
                      <FaReceipt className="me-2 text-danger" /> Payment Details
                    </h5>
                    <div className="payment-info">
                      <div className="detail-item">
                        <span className="text-muted small">Mode</span>
                        <span className="fw-semibold small">
                          {paymentData.Mode}
                        </span>
                      </div>
                      {paymentData.Mode === "UPI" && paymentData.UpiVa && (
                        <div className="detail-item mt-2">
                          <span className="text-muted small">UPI ID</span>
                          <span className="fw-semibold small">
                            {paymentData.UpiVa || "N/A"}
                          </span>
                        </div>
                      )}
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Date</span>
                        <span className="fw-semibold small">
                          {new Date(paymentData?.Addedon).toLocaleDateString()}
                        </span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Status</span>
                        <span
                          className={`badge ${
                            paymentData.Status === "success"
                              ? "bg-success"
                              : "bg-danger"
                          } small`}
                        >
                          {paymentData.Status || "failure"}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="ps-md-2 mt-3 mt-md-0">
                  <div className="customer-details h-100" style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                    <h5 className="mb-3 d-flex align-items-center">
                      <FaUser className="me-2 text-danger" /> Customer Details
                    </h5>
                    <div className="customer-info">
                      <div className="detail-item">
                        <span className="text-muted small">Name</span>
                        <span className="fw-semibold small">
                          {paymentData.Firstname}
                        </span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Email</span>
                        <span className="fw-semibold small">
                          {paymentData.Email}
                        </span>
                      </div>
                      <div className="detail-item mt-2">
                        <span className="text-muted small">Phone</span>
                        <span className="fw-semibold small">
                          {paymentData.Phone}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>{" "}
              <div className="text-center mt-4">
                {paymentData.Status !== "success" && (
                  <div className="error-status mb-3">
                    <FaExclamationTriangle className="text-danger me-2" />
                    <span className="text-danger">
                      {paymentData.ErrorMessage ||
                        paymentData.Error ||
                        "Transaction Failed"}
                    </span>
                  </div>
                )}
                <div className="d-flex justify-content-center">
                  {" "}
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="px-4 me-2"
                    onClick={() => {
                      // Navigate back to subscription page to try again
                      navigate("/home/subscription");
                    }}
                  >
                    Try Again
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="px-4"
                    onClick={() => {
                      // Navigate to dashboard
                      navigate("/home");
                    }}
                  >
                    Return to Dashboard
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentFailure;
